module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAXCAMAAAC/B6aqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUxpcQCF/wCP/wCF/wCF/wCF/wCS/wCF/wCJ/wCI/wCE/wCF/wCF/wCF/wCF/wCE/wCE/0VfK14AAAAQdFJOUwCUDrXQ3wf1GizC66g+R4OaUGqIAAAAWklEQVQoz43KSw5AQBQAwcYw/tz/tBYiIvPQtS52ZUO1CmRDNvFm1Dvb72s69a7288arfb+xxrx0N2T7eKnHvPbRkA3ZXt40YF7ZkC16OWjBywvmxa14eQ3bAf98J/FhA/tiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/selected_right.png
// module id = 40
// module chunks = 0